import React from "react";
import { Badge } from "@/components/ui/badge";
import { STATUS_LABELS } from "@/lib/format";

const STYLES = {
  new: "bg-[rgba(183,165,142,0.22)] text-[#18344A] border-[rgba(183,165,142,0.5)]",
  contacted: "bg-[rgba(82,110,126,0.14)] text-[#526E7E] border-[rgba(82,110,126,0.3)]",
  confirmed: "bg-[rgba(24,52,74,0.1)] text-[#18344A] border-[rgba(24,52,74,0.25)]",
  lost: "bg-[rgba(120,144,156,0.16)] text-[rgba(48,56,60,0.7)] border-[rgba(82,110,126,0.2)]",
  booked: "bg-[rgba(82,110,126,0.14)] text-[#526E7E] border-[rgba(82,110,126,0.3)]",
  seated: "bg-[rgba(24,52,74,0.1)] text-[#18344A] border-[rgba(24,52,74,0.25)]",
  completed: "bg-[rgba(24,52,74,0.12)] text-[#18344A] border-[rgba(24,52,74,0.3)]",
  cancelled: "bg-[rgba(120,144,156,0.16)] text-[rgba(48,56,60,0.7)] border-[rgba(82,110,126,0.2)]",
  no_show: "bg-[rgba(190,60,60,0.1)] text-[#9a3a3a] border-[rgba(190,60,60,0.25)]",
};

export function StatusBadge({ status }) {
  return (
    <Badge
      variant="outline"
      data-testid={`status-badge-${status}`}
      className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${STYLES[status] || STYLES.lost}`}
    >
      {STATUS_LABELS[status] || status}
    </Badge>
  );
}
